import React from "react";

import { BrandProfileSummary } from "@faire/retailer/components/LoggedOutBrand/BrandProfileSummary";
import type { IBrandProfileSummaryProps } from "@faire/retailer/components/LoggedOutBrand/BrandProfileSummary";
import { Wrapper } from "@faire/retailer/views/brand/logged-out/components/common";

export const BrandInfo = React.forwardRef<
  HTMLDivElement,
  IBrandProfileSummaryProps
>((brandProfileSummaryProps, ref) => {
  return (
    <Wrapper ref={ref}>
      <BrandProfileSummary {...brandProfileSummaryProps} />
    </Wrapper>
  );
});
